import React, { Children } from "react";
import { useRecoilState } from "recoil";
import { getCertificateCreateFormAtom } from "raft/CertificateForm";
import Props from "./index.d";
import { StyledUnitRowForSwitchingOperationCheckbox } from "./styles";

interface GFCFieldSet_SwitchOperationCheckboxWrapperExtended extends Props {
  children: React.ReactNode;
}
/**
 * Only renders children if category is ASYNCHRONOUS_GENERATOR or SYNCHRONOUS_GENERATOR
 * and normList includes 10, 20, or 30. Otherwise returns null.
 */
const SwitchOperationCheckboxWrapper: React.FC<GFCFieldSet_SwitchOperationCheckboxWrapperExtended> = ({
  children,
  className,
}) => {
  const childrenCount = Children.count(children);
  const createUnitAtom = getCertificateCreateFormAtom({});
  const [certificateValues] = useRecoilState(createUnitAtom);
  const category = certificateValues?.category;
  const normList = certificateValues?.__normList;

  const isGen = category === "ASYNCHRONOUS_GENERATOR" || category === "SYNCHRONOUS_GENERATOR";
  const normOk = typeof normList === "string" && ["10", "20", "30"].some((n) => normList.includes(n));

  if (!isGen || !normOk || !category) {
    return null;
  }

  return (
    <StyledUnitRowForSwitchingOperationCheckbox isSingle={childrenCount === 1} className={className}>
      {children}
    </StyledUnitRowForSwitchingOperationCheckbox>
  );
};

export default SwitchOperationCheckboxWrapper;
